/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default {
  simple: Yup.object().shape({
    name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        50,
        i18n.t('MAX_LENGTH_KEY', {
          value: 50,
        })
      ),
  }),
  advanced: Yup.object().shape({
    name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        50,
        i18n.t('MAX_LENGTH_KEY', {
          value: 50,
        })
      ),
    application_path: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    application_parameters: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    display_name: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  }),
};
